export default __webpack_public_path__ + "c746b7a264999b00ebeab6624bbd96c7.png";